import react from "react";
import EmptyIcon from "../../assets/imgs/Empty.svg";
import styles from "./EmptyCard.module.css";
import Image from "next/image";
import Buttons from "../Button/Button";

function EmptyCard(props) {
  return (
    <div
      className={styles.EmptyCard}
      style={{
        border: props.BorderStatus,
        boxShadow: props.BorderStatus,
        minHeight: props.MinHeight,
        padding: props.Padding,
      }}
    >
      {props.CardImg && (
        <Image className={styles.EmptyCardIcon} src={EmptyIcon} />
      )}
      {props.Icon}
      <h1>{props.title}</h1>
      <p>{props.description}</p>
      {props.showButton && (
        <Buttons
          label={props.btnLabel}
          buttonColor="#004FE0"
          color="#fff"
          width=""
          height="40px"
          fontSize="14px"
          link={props.btnLink}
          target={props.target}
        />
      )}
    </div>
  );
}

export default EmptyCard;

{
  /* <EmptyCard
          Icon={<InfoIcon />}
          description="You do not have any recent courses."
          showButton={true}
          btnLabel="Explore Courses"
        /> */
}
